import { Table } from '@mantine/core';

//TableRow
export const TableTr = ({ children }) => {
  return <Table.Tr>{children}</Table.Tr>;
};
